/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The type of the service group.<br>
 *
 * @remarks
 * `LIVE_RATE` - Shippo will make a rating request and return real-time rates for the shipping group, only falling back to the specified flat rate amount if no rates match a service level in the service group.<br>
 * `FLAT_RATE` - Returns a shipping option with the specified flat rate amount.<br>
 * `FREE_SHIPPING` - Returns a shipping option with a price of $0 only if the total cost of items exceeds the amount defined by `free_shipping_threshold_min`
 */
export const ServiceGroupTypeEnum = {
  LiveRate: "LIVE_RATE",
  FlatRate: "FLAT_RATE",
  FreeShipping: "FREE_SHIPPING",
} as const;
/**
 * The type of the service group.<br>
 *
 * @remarks
 * `LIVE_RATE` - Shippo will make a rating request and return real-time rates for the shipping group, only falling back to the specified flat rate amount if no rates match a service level in the service group.<br>
 * `FLAT_RATE` - Returns a shipping option with the specified flat rate amount.<br>
 * `FREE_SHIPPING` - Returns a shipping option with a price of $0 only if the total cost of items exceeds the amount defined by `free_shipping_threshold_min`
 */
export type ServiceGroupTypeEnum = ClosedEnum<typeof ServiceGroupTypeEnum>;

/** @internal */
export const ServiceGroupTypeEnum$inboundSchema: z.ZodNativeEnum<
  typeof ServiceGroupTypeEnum
> = z.nativeEnum(ServiceGroupTypeEnum);

/** @internal */
export const ServiceGroupTypeEnum$outboundSchema: z.ZodNativeEnum<
  typeof ServiceGroupTypeEnum
> = ServiceGroupTypeEnum$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ServiceGroupTypeEnum$ {
  /** @deprecated use `ServiceGroupTypeEnum$inboundSchema` instead. */
  export const inboundSchema = ServiceGroupTypeEnum$inboundSchema;
  /** @deprecated use `ServiceGroupTypeEnum$outboundSchema` instead. */
  export const outboundSchema = ServiceGroupTypeEnum$outboundSchema;
}
